import { Wrench, Store, Truck, MapPin } from "lucide-react";
import { WhatsAppIcon, buildWhatsAppLink } from "./Header";

const ICONS = { wrench: Wrench, store: Store, truck: Truck };

const DEFAULT_SERVICES = [
  { icon: "wrench", title: "Assistência Técnica", text: "Troca de tela, bateria, conector e reparos em geral. Peça seu orçamento pelo WhatsApp sem compromisso.", button_label: "Pedir Orçamento no WhatsApp", button_type: "whatsapp" },
  { icon: "store", title: "Loja Física", text: "Venha conhecer os produtos de perto, retirar seu pedido ou deixar seu aparelho para avaliação.", button_label: "Como Chegar", button_type: "maps" },
  { icon: "truck", title: "Entrega e Envio", text: "Entrega rápida na nossa cidade e região, e enviamos para todo o Brasil com embalagem protetora.", button_label: "Calcular Frete pelo CEP", button_type: "anchor" },
];

export default function Services({ whatsappNumber, address, hours, services }) {
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address || "")}`;
  const list = services?.length ? services : DEFAULT_SERVICES;

  const buttonFor = (s) => {
    if (s.button_type === "maps") {
      return { href: mapsUrl, external: true, testid: `service-maps-${s.title}`, style: "bg-[#1A1816] text-white hover:bg-[var(--brand)]", icon: <MapPin className="w-4 h-4" /> };
    }
    if (s.button_type === "anchor") {
      return { href: "#simuladores", external: false, testid: `service-anchor-${s.title}`, style: "border border-[#D5CDC2] text-[#1A1816] hover:border-[#1A1816]", icon: null };
    }
    return {
      href: buildWhatsAppLink(whatsappNumber, `Olá! Quero pedir um orçamento: ${s.title}. Modelo do aparelho: `),
      external: true,
      testid: `service-whatsapp-${s.title}`,
      style: "bg-[var(--brand)] text-white hover:bg-[var(--brand-dark)]",
      icon: <WhatsAppIcon />,
    };
  };

  return (
    <section id="diferenciais" className="py-24 px-6 max-w-6xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {list.map((s) => {
          const Icon = ICONS[s.icon] || Wrench;
          const btn = buttonFor(s);
          return (
            <div
              key={s.title}
              data-testid={`service-${s.title}`}
              className="p-8 rounded-3xl bg-[#F2EDE4] border border-[#E8E2D9] hover:border-[var(--brand)] transition-colors flex flex-col"
            >
              <Icon className="w-7 h-7 text-[var(--brand)] mb-4" />
              <h3 className="font-display font-bold text-xl mb-3">{s.title}</h3>
              <p className="text-sm text-[#5A534C] leading-relaxed mb-2">{s.text}</p>
              {s.button_type === "maps" && address && (
                <p className="text-xs font-mono text-[#6B645C] mb-2" data-testid="store-address">{address}</p>
              )}
              {s.button_type === "maps" && hours && (
                <p className="text-xs font-mono text-[#6B645C] mb-2" data-testid="store-hours">{hours}</p>
              )}
              <div className="mb-4 flex-1" />
              <a
                href={btn.href}
                {...(btn.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                data-testid={btn.testid}
                className={`inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full font-display text-xs uppercase tracking-wider font-semibold transition-colors ${btn.style}`}
              >
                {btn.icon} {s.button_label}
              </a>
            </div>
          );
        })}
      </div>
    </section>
  );
}
